export default __webpack_public_path__ + "opus-encoderWorker.min.8bd8ff5.js";